import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { costCenterInitialsForAdd, costCenterInitialsForUpdate } from './interfaces/costCenterClass';
import { addCostCenterAsync, UpdateCostCenterAsync, resetSelectedRecordObjectInState } from './costCenterSlice';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import { getValueFromResource } from '../../../common/timeLiveFunction';

const CodeCenterForm = (props: any) => {
    const [disabledCount, setDisabledCount] = useState(0)
    const { t, oncloseModal } = props;
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(costCenterInitialsForAdd);
    const { selectedRecord, costCenterList, isLoading } = useAppSelector((state) => state.costCenter);
    const dispatch = useAppDispatch();
    const defaultFocusRef = useRef<HTMLInputElement>(null);

    useEffect(() => {

        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {

            const tempObj: any = selectedRecord;
            Object.keys(costCenterInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === "Yes" ? true : false;
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(costCenterInitialsForAdd);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }

        calculatedDisabledValue();
    }, [selectedRecord])
    const handleTextChange = (e: any) => {
        setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) })
    }
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);


    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {

            dispatch(UpdateCostCenterAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast('Cost Center Update Successfully', 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.message, "error", "toast-top-right");

                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
        else {
            dispatch(addCostCenterAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast('Cost Center Added Successfully', 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.message, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
        oncloseModal();
    }
    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
        oncloseModal();
    }

    const calculatedDisabledValue = () => {
        if (costCenterList.length > 0) {
            let index = 0;
            costCenterList.forEach((value) => {
                if (value.IsDisabled.toString() == 'Yes') {
                    index = index + 1
                }
            });
            setDisabledCount(costCenterList.length - index);
        }
    }
    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    SortOrder: yup
                        .string()
                        .label('SortOrder')
                        .trim()
                        .required
                        // (t('Sort order is required')),
                        (getValueFromResource('Sort order is required',dispatch, t)),
                    AccountCostCenterCode: yup
                        .string()
                        .label('AccountCostCenterCode')
                        .trim()
                        .required
                        (getValueFromResource('Cost Center Code is required',dispatch, t)),
                    AccountCostCenter: yup
                        .string()
                        .label('AccountCostCenter')
                        .trim()
                        .required
                        // (t('Cost Center is required'))
                        (getValueFromResource('Cost Center is required',dispatch, t)),


                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <div className="modal drawer-overlay" style={{ display: 'block' }}>
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                        <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ?
                                        //  t('Update') 
                                        getValueFromResource('Update ',dispatch, t)
                                        //  : t('Add')}
                                       : getValueFromResource('Add ',dispatch, t)}
                                          {/* {t('Cost Center')}  */}
                                       {  getValueFromResource('Cost Center',dispatch, t)}
                                          </h5>
                                        <div
                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                            onClick={oncloseModal}
                                        >
                                            <KTSVG
                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                className="svg-icon svg-icon-1x"
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-body">
                                        <div className="mb-3">
                                            <label className="fs-7 fs-7 fw-normal mb-2">
                                                {/* {t('Sort Order')} */}
                                                {getValueFromResource('Sort Order',dispatch, t)}                                              
                                                  </label>
                                            <input
                                                ref={defaultFocusRef}
                                                type="number"
                                                className="form-control fs-7 fw-normal"
                                                id='SortOrder'
                                                name='SortOrder'
                                                value={values.SortOrder}
                                                onChange={handleChange('SortOrder')}
                                            // onBlur={() => setFieldTouched('SortOrder')}
                                            />
                                            <div style={{ paddingRight: 20 }}>
                                                {touched.SortOrder && errors.SortOrder &&
                                                    <p className='errorMsg'>{errors.SortOrder as string}</p>
                                                }
                                            </div>
                                        </div>


                                        <div className="mb-3 mt-2">
                                            <label className="fs-7 fs-7 fw-normal mb-2">
                                                {/* {t('Cost Center Code')} */}
                                                {getValueFromResource('Cost Center Code',dispatch, t)}
                                                </label>
                                            <input
                                                type="text"
                                                className="form-control fs-7 fw-normal"
                                                id='AccountCostCenterCode'
                                                name='AccountCostCenterCode'
                                                value={values.AccountCostCenterCode}
                                                onChange={handleChange('AccountCostCenterCode')}

                                            />
                                            <div style={{ paddingRight: 20 }}>
                                                {touched.AccountCostCenterCode && errors.AccountCostCenterCode &&
                                                    <p className='errorMsg'>{errors.AccountCostCenterCode as string}</p>
                                                }
                                            </div>
                                        </div>


                                        <div className="mb-3">
                                            <label className="fs-7 fs-7 fw-normal mb-2">
                                                {/* {t('Cost Center')} */}
                                                {getValueFromResource('Cost Center',dispatch, t)}
                                                </label>
                                            <input
                                                type="text"
                                                className="form-control fs-7 fw-normal"
                                                id='AccountCostCenter'
                                                name='AccountCostCenter'
                                                value={values.AccountCostCenter}
                                                onChange={handleChange('AccountCostCenter')}
                                                // onBlur={() => setFieldTouched('AccountCostCenter')}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        setFieldTouched('AccountCostCenter', true);
                                                        handleSubmit();
                                                    }
                                                }}
                                            />
                                            <div style={{ paddingRight: 20 }}>
                                                {touched.AccountCostCenter && errors.AccountCostCenter &&
                                                    <p className='errorMsg'>{errors.AccountCostCenter as string}</p>
                                                }
                                            </div>
                                        </div>

                                        {Object.keys(selectedRecord).length > 0 ? (
                                            disabledCount !== 1 ? <div className="mb-3" >
                                                <label className="fs-7 fw-normal mt-2">
                                                    {/* {t('Disabled')} */}
                                                    {getValueFromResource('Disabled',dispatch, t)}
                                                    </label>
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                        onChange={handleChange('IsDisabled')}
                                                    />
                                                </div>
                                            </div> : costCenterList.find(x => x.AccountCostCenterId === values.AccountCostCenterId)?.IsDisabled.toString() === "Yes" && (<div className="mb-3" >
                                                <label className="fs-7 fw-normal mt-2">
                                                    {/* {t('Disabled')} */}
                                                    {getValueFromResource('Disabled',dispatch, t)}
                                                    </label>
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                        onChange={handleChange('IsDisabled')}
                                                    />
                                                </div>
                                            </div>)
                                        ) : null}

                                    </div>
                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }}>
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                            onClick={handleCloseOnClickEvent}
                                        >
                                            {/* {t('Cancel')} */}
                                            {getValueFromResource('Cancel',dispatch, t)}
                                        </button>
                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}
                                        >
                                            {/* {t('Save')} */}
                                            {getValueFromResource('Save',dispatch, t)}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Formik>
        </>
    )

}
export default CodeCenterForm